import { useAuth } from '../hooks/useAuth';
import api, { loginapi } from './apiconfig'
import  axios, { AxiosResponse } from 'axios';


/** history of a room (room) or of a VBUS sensor (device), exactly one of both */
export interface IGraphArgs {
    room?: string
    device?: string
    start: string
    every: string
}

interface IGraphData {
    timestamp: string
    value: number
}



const responseBody = (response: AxiosResponse) => response.data;


const requests = {
	// errors are passed on to the caller so a failed fetch is not mistaken for an empty state
	get: (url: string) => api.get(url).then( (responseBody) => {
        const { rooms, heating, vbus, lights, live } = responseBody.data
        if (!Array.isArray(rooms) || !Array.isArray(heating) || !Array.isArray(vbus)) {
            throw new Error('invalid state response')
        }
        return {rooms: rooms as Array<IRoomState>, heating : heating, vbus: vbus as Array<IVBus>, lights: Array.isArray(lights) ? lights as Array<ILight> : [], live: live === true} }),
    getGraph: (url:string, payload:IGraphArgs) => api.post(url,payload).then((responseBody) => {
        return responseBody.data as Array<IGraphData>
    }),


	post: (url: string, body: {}) => api.post(url, body).then(responseBody),
	put: (url: string, body: {}) => api.put(url, body).then(responseBody),
	delete: (url: string) => api.delete(url).then(responseBody),
    loginpost: (url: string, body: {}) => loginapi.post(url, body).then(responseBody).catch(responseBody),
};


interface ITemp {
    address: string;
    temperatur : number
}

export interface IRoomState {
    result: string,
    table : string,
    _start: string,
    _stop : string,
    room: string,
    HUMIDITY: string,
    SETPOINT: string,
    STATE: string,
    TEMPERATURE: string,
    TARGETON: string,
    TARGETOFF: string
}

export interface IVBus {
    device :  string,
    protocol : string,
    result : string,
    room : string,
    table : string
    _field : string,
    _measurement: string,
    _start : string,
    _stop : string,
    _time : string,
    _value : string
}

export interface ILight {
    id: string
    name: string
    on: boolean
}

export interface IChaletState {
    rooms: Array<IRoomState> 
    heating : any 
    vbus: Array<IVBus>
    /** true: device states read live from the CCU; false: taken from InfluxDB, may be outdated */
    live?: boolean
    lights?: Array<ILight>
}

export interface IDeviceState {
    channel: string;
    datapoint : string;
    value : number | string,
    hminterface : string
}

export interface ILogin {
    message: string,
    token: string
}

export interface ITarget {
    room: string,
    target: string,
    value: number
}

interface IResult {
    returncode: number
    message: string
}


export const HMChalet = {
	getChaletState: (): Promise<IChaletState> => {
        return requests.get(`state`)},
    writeTarget: (target:ITarget) : Promise<IResult> => {
        return requests.post('target',target)
    }, 
    postHMState: (state: IDeviceState) : Promise<IDeviceState> => {
        var resp = requests.post('hmgateway', state)
        console.log('resp:',resp)
        return resp },
    setLight: (id: string, on: boolean) => requests.post('lights', { id, on }),
    getGraphData: (payload:IGraphArgs) : Promise<Array<IGraphData>> => {
        return requests.getGraph('graph',payload)
    },
    login: (username:string,password:string): Promise<ILogin> => requests.loginpost('login',{username,password})
    };
